import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const AuthLogin = ({ onLogin }) => {
  const location = useLocation();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(true);
    }, 1);

    return () => clearTimeout(timer);
  }, []);

  const checkToken = async (token, url) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_AUTH_URL}/api/auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      });

      if (response.status === 200) {
        onLogin();
      } else {
        localStorage.removeItem("accessToken");
        window.location.href = url;
      }
    } catch (error) {
      console.error("Failed to verify token:", error);

    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    let token = queryParams.get("token");
 
    let host = '';

    if (typeof window !== 'undefined') {
      host = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
    }

    const redirectUrl = process.env.REACT_APP_AUTH_URL || "";
    
    // Validate redirectUrl
    if (!redirectUrl) {
      console.error("REACT_APP_AUTH_URL is not defined or empty.");
      return;
    }

    try {
      const url = new URL(redirectUrl);
      url.searchParams.set("redirect_url", host);

      if (token) {
        localStorage.setItem("accessToken", token);
        checkToken(token, url.toString());
      } else {
        token = localStorage.getItem("accessToken");
        if (token) {
          checkToken(token, url.toString());
        } else {
           window.location.href = url;
        }
      }
    } catch (error) {
      console.error("Failed to construct URL:", error);
    }
  }, [location.search]);

  return (
    <div>
      <p>Loading...</p>
    </div>
  );
};

export default AuthLogin;
